import { render } from "./Form.vue?vue&type=template&id=55f7062e&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=55f7062e&scoped=true&lang=scss"

import exportComponent from "/Users/vhstrejo/Sites/crowdfunding/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f7062e"]])

export default __exports__